import React from 'react';
import { EffectComposer, Bloom, Vignette } from '@react-three/postprocessing';

/** Master switch — flip to false if low-end perf tanks. */
export const FACILITY_POSTFX_ENABLED = true;

/**
 * Soft bloom on emissives + gentle vignette. No per-frame React state.
 */
export function FacilityPostFX() {
  if (!FACILITY_POSTFX_ENABLED) return null;
  return (
    <EffectComposer multisampling={0}>
      <Bloom
        luminanceThreshold={0.55}
        luminanceSmoothing={0.4}
        intensity={0.45}
        mipmapBlur
      />
      <Vignette offset={0.25} darkness={0.55} />
    </EffectComposer>
  );
}
